import { Navigate, useLocation } from 'react-router-dom';
import { buildTenantAppPath, resolveTenantSlug } from 'shared/utils/tenantPath';

/**
 * Sends legacy unprefixed URLs (e.g. /dashboard) to /{tenantName}/dashboard.
 */
export default function LegacyTenantPathRedirect() {
  const location = useLocation();
  const slug = resolveTenantSlug();
  if (!slug) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  const target = buildTenantAppPath(
    `${location.pathname}${location.search || ''}${location.hash || ''}`,
    slug
  );
  return <Navigate to={target} replace state={location.state} />;
}
